<template>
  <div class="login-page">
    <div class="center-el">
      <div class="manage-tip">
        <p>登录招聘系统</p>
      </div>
      <section class="form_container">
        <el-form
          ref="loginForm"
          :model="loginForm"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item prop="phone" class="login-input">
            <el-input v-model="loginForm.phone" placeholder="手机号" />
          </el-form-item>
          <el-form-item prop="imageValid" class="login-input">
            <div class="phone-code">
              <el-input
                style="width: 180px"
                v-model="loginForm.imageCode"
                placeholder="请输入图形验证码"
              ></el-input>
              <a>
                <div class="img" @click="refreshImageCode()">
                  <img :src="image" alt />
                </div>
              </a>
            </div>
          </el-form-item>
          <el-form-item prop="imageValid" class="login-input">
            <div class="phone-code">
              <el-input
                style="width: 180px"
                v-model="loginForm.phoneCode"
                placeholder="请输入短信验证码"
              ></el-input>
              <el-button
                class="form-button"
                type="primary"
                style="width: 120px"
                @click="sendPhoneCode"
                >获取验证码</el-button
              >
            </div>
          </el-form-item>
          <el-form-item class="login-button">
            <el-button
              type="primary"
              native-type="submit"
              @click.native.prevent="handleLogin"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="notice">
        <div>支持浏览器：Chrome、Firefox、Edge</div>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { getImageCode, login, loginSendPhoneCode } from "@/api/user";

export default {
  name: "Login",

  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入正确用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码长度不能少于6"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
        imageCode: "",
      },
      image: "",
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      publicKey:
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCHjcTt+NQ+TbUrp4+OPbZNoeNS43JWrYA0KRvy7IButcrMIwQeXGorGcdpJV49R1K6J+dqGJc69mfLLBNH87wU88ToBmknQYPnmo/YNOX7W9VsXwAQqE5OvB5waZR5/vr7FabEAp2lYiNUHr1ag4ygTtR690gos8Ueq4ZQphzelQIDAQAB",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    
    this.refreshImageCode();
    // if (this.loginForm.username === "") {
    //   this.$refs.username.focus();
    // } else if (this.loginForm.password === "") {
    //   this.$refs.password.focus();
    // }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    sendPhoneCode() {
      if (!this.loginForm.phone || this.loginForm.phone === "") {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!this.loginForm.imageCode || this.loginForm.imageCode === "") {
        this.$message.error("请输入图形验证码");
        return;
      }
      loginSendPhoneCode({
        phone: this.loginForm.phone,
        imageCode: this.loginForm.imageCode,
      }).then((res) => {
        if (res.data.errorCode === "0") {
          this.$notify({
            title: "成功",
            message: "短信发送成功",
            type: "success",
            duration: 3000,
          });
          
        } else {
          this.$notify.error({
            title: "错误",
            message: res.data.message,
          });
        }
      });
    },
    refreshImageCode() {
      getImageCode().then((res) => {
        this.image = res.data.data;
      });
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      // var jse = new JsEncrypt();
      // jse.setPublicKey(this.publicKey);
      // var passwordCode = jse.encrypt(this.loginForm.password);
      if (!this.loginForm.phone || this.loginForm.phone === "") {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!this.loginForm.phoneCode || this.loginForm.phoneCode === "") {
        this.$message.error("请输入手机验证码");
        return;
      }
      login({
        phone: this.loginForm.phone,
        phoneCode: this.loginForm.phoneCode,
      }).then((res) => {
        console.log("登录结果", res);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("user", res.data.data);
        this.$store.commit('setLogin', '1')
        this.$router.push({
          path: "/",
          query: {},
        });
      });
    },
    refreshImageCode() {
      getImageCode().then((res) => {
        this.image = res.data.data;
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },
};
</script>

<style >
</style>

<style scoped>
.login-page {
  /* background-image: url("../assets/back-image.jpeg"); */

  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.center-el {
  /* height: 800px; */
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.form_container {
  border: 1px;
  width: 370px;
  height: 400px;
  padding: 20px 0;
  /* margin-bottom: 100px; */
  background-color: #fff;
  opacity: 0.9;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  width: 100%;
  height: 220px;
  margin-bottom: 30px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.login-form .login-input {
  width: 320px;
  margin-bottom: 0;
}

.login-form .login-input .el-input__inner {
  height: 35px;
}

.login-form .login-button {
  display: inline-flex;
  justify-content: center;
}

.login-form .login-button button {
  width: 320px;
}

.manage-logo {
  padding: 10px;
}

.manage-logo img {
  width: 180px;
}

.manage-tip {
  width: 100%;
  text-align: center;

  margin-bottom: 50px;
  opacity: 0.8;
}

.manage-tip p {
  font-size: 34px;
  color: #606266;
  text-align: center;
}

.phone-code {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.phone-code .img {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.phone-code .img img {
  max-width: 120px;
  max-height: 100%;
}

.notice{
  font-size: 12px;
  margin-top: 50px;
  position:absolute;
  /* left: 50%; */
  bottom: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Login.vue?4098cb4e